import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import Vuelidate from "vuelidate";
import Vuex from "vuex";
import store from "@/store/index"

Vue.config.productionTip = false
Vue.use(Vuelidate)
Vue.use(Vuex)

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
